import { FormTagEnum } from "@appNeo/neoShared/helpers/enums/FormTag.enum";
import { PerfilPropiedadTagEnum } from "@appNeo/neoShared/helpers/enums/perfil-propiedad-tag.enum";
import { TagCampoEnum } from "@appNeo/neoShared/helpers/enums/TagCampo.enum";
import { TipoDatePickerEnum } from "@appNeo/neoShared/helpers/enums/TipoDatePicker.enum";
import { ClasesCampoLayoutCamposPorcentajeFormularioEnum, IFormInput } from "@appNeo/neoShared/helpers/interfaces/IForm-input";
import { IPerfilPropiedad } from "@appNeo/neoShared/helpers/interfaces/IPerfilPropiedad";

import { IClasesCeldas, IColumnaTabla, TipoColumnaTablaEnum } from "@appNeo/neoShared/services/tabla/tabla.service";


export const COLUMNAS: IColumnaTabla[] = [
    // {key: 'select', nombre: '', tipo: TipoColumnaTablaEnum.Selector, tagCampo: TagCampoEnum.Selector, ordenacion: false},
    {
        key: 'identificador',
        nombre: 'Identificador',
        tipo: TipoColumnaTablaEnum.EnlacePrincipal,
        tagCampo: TagCampoEnum.EnlacePrincipal,
        ordenacion: true,
        clasePersonalizada: [IClasesCeldas.cell100]
    },
    {
        key: 'fechaEvento',
        nombre: 'Fecha',
        tipo: TipoColumnaTablaEnum.Fecha,
        tagCampo: TagCampoEnum.Date,
        tipoDatePicker: TipoDatePickerEnum.Fecha,
        ordenacion: true,
        clasePersonalizada: [IClasesCeldas.cell120]
    },
    {
        key: 'idTipoTurno',
        nombre: 'Turno',
        tipo: TipoColumnaTablaEnum.Texto,
        tagCampo: TagCampoEnum.Input,
        ordenacion: true,
        clasePersonalizada: [IClasesCeldas.cell120]
    },
    {
        key: 'descripcion',
        nombre: 'Descripcion',
        tipo: TipoColumnaTablaEnum.Texto,
        tagCampo: TagCampoEnum.Editor,
        ordenacion: true,
        clasePersonalizada: [IClasesCeldas.cell120]
    },
    // {key: 'acciones',    nombre: 'Acciones',  tagCampo: TagCampoEnum.Acciones,   tipo: TipoColumnaTablaEnum.Acciones,  ordenacion: false},
];


export const INPUTSFILTROS: IFormInput[] = [
    {
        tag: FormTagEnum.date,
        tipoDatePicker: TipoDatePickerEnum.Fecha,
        label: 'Desde',
        type: 'fecha',
        placeholder: 'Desde',
        formControlName: 'fechaEventoDesde',
        validadores: [''],
    },
    {
        tag: FormTagEnum.date,
        tipoDatePicker: TipoDatePickerEnum.Fecha,
        label: 'Hasta',
        type: 'fecha',
        placeholder: 'Hasta',
        formControlName: 'fechaEventoHasta',
        validadores: [''],
    },
    {
        tag: FormTagEnum.select,
        label: 'Turno',
        type: '',
        placeholder: 'Turno',
        formControlName: 'idTipoTurno',
        validadores: ['']
    },
];


export const FORMINPUT: IFormInput[] = [
    {
        tag: FormTagEnum.date,
        tipoDatePicker: TipoDatePickerEnum.Fecha,
        label: 'Fecha',
        type: 'text',
        placeholder: 'Fecha',
        formControlName: 'fechaEventoDate',
        // textoAyuda: 'Texto opcional de ayuda',
        obligatorio: true,
        disabled: false,
        validadores: [''],
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent2x]
    },
    {
        tag: FormTagEnum.select,
        label: 'Turno',
        type: '',
        placeholder: 'Turno',
        obligatorio: true,
        formControlName: 'idTipoTurno',
        validadores: ['']
    },
    {
        tag: FormTagEnum.editor,
        label: 'Descripcion',
        type: '',
        placeholder: 'Descripcion',
        formControlName: 'descripcion',
        validadores: ['']
    },
];

export const PROPIEDADES_PERFIL: IPerfilPropiedad[] = [
    {
        tag: PerfilPropiedadTagEnum.Fecha,
        tagCampo: TagCampoEnum.Input,
        label: 'Fecha',
        identificador: 'fechaEvento',
        // clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
    },
    {
        tag: PerfilPropiedadTagEnum.Basico,
        tagCampo: TagCampoEnum.Input,
        identificador: 'idTipoTurno',
        label: 'Turno',
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent1x],
    },
    {
        label: 'Descripcion',
        tag: PerfilPropiedadTagEnum.Basico,
        tagCampo: TagCampoEnum.Textarea,
        identificador: 'descripcion',
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x]
    },
];


export const FORMINPUT_PERFIL: IFormInput[] = [
    {
        tag: FormTagEnum.date,
        tipoDatePicker: TipoDatePickerEnum.Fecha,
        label: 'Fecha',
        type: 'fecha',
        placeholder: 'Fecha',
        formControlName: 'fechaEventoDate',
        validadores: [''],
    },
    {
        tag: FormTagEnum.select,
        label: 'Turno',
        type: 'text',
        placeholder: 'Turno',
        formControlName: 'idTipoTurno',
        // textoAyuda: 'Texto opcional de ayuda',
        obligatorio: true,
        validadores: [''],
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent1x]
    },
    {
        tag: FormTagEnum.editor,
        label: 'Descripción',
        type: '',
        textoAyuda: '',
        placeholder: 'Descripción',
        formControlName: 'descripcion',
        obligatorio: false,
        validadores: [],
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
    },
];